import React from 'react'
import Header from '../components/Header'
import HomeServices from '../components/HomeServices'

const Home = () => {
    return (
        <div className="relative">
            <div className="absolute -top-52 -left-64 opacity-25 -z-10 hidden lg:block">
                <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" width="20rem" id="blobSvg" >
                    <path id="blob" d="M411,351.5Q367,453,258.5,438.5Q150,424,95.5,337Q41,250,92,157.5Q143,65,254,58.5Q365,52,410,151Q455,250,411,351.5Z" fill="#a29bfe"></path>
                </svg>
            </div>
            {/* header  */}
            <Header />

            <div className="trasition duration-700 ease-linear absolute -top-32 -right-52 opacity-10 -z-10 hidden lg:block">
                <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" width="50rem" id="blobSvg" >
                    <path id="blob" d="M411,351.5Q367,453,258.5,438.5Q150,424,95.5,337Q41,250,92,157.5Q143,65,254,58.5Q365,52,410,151Q455,250,411,351.5Z" fill="#a29bfe"></path>
                </svg>
            </div>

            {/* services  */}
            <HomeServices />
        </div>
    )
}

export default Home
